(function () {
  class ImageTextBlocksSection extends HTMLElement {
    constructor() {
      super();
      this._onSmoothClick = this._onSmoothClick.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
    }

    connectedCallback() {
      this._bindSmoothScroll();
      document.addEventListener('shopify:section:load', this._onSectionLoad);
    }

    disconnectedCallback() {
      this._unbindSmoothScroll();
      document.removeEventListener('shopify:section:load', this._onSectionLoad);
    }

    _bindSmoothScroll() {
      this._unbindSmoothScroll();
      this.querySelectorAll('a.js-smoothScroll').forEach((el) => {
        el.addEventListener('click', this._onSmoothClick);
      });
    }

    _unbindSmoothScroll() {
      this.querySelectorAll('a.js-smoothScroll').forEach((el) => {
        el.removeEventListener('click', this._onSmoothClick);
      });
    }

    _onSectionLoad(event) {
      var target = event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._bindSmoothScroll();
      }
    }

    _onSmoothClick(ev) {
      ev.preventDefault();
      var elLink = ev.currentTarget;
      var href = elLink.getAttribute('href');
      if (!href || href.indexOf('#') === -1) {
        return;
      }

      var parts = href.split('#');
      var sectionId = parts.length > 1 ? parts[parts.length - 1] : '';
      if (!sectionId) {
        return;
      }

      var elSection = document.getElementById(sectionId);
      if (!elSection) {
        return;
      }

      var rect = elSection.getBoundingClientRect();
      var targetY = rect.top;
      var currentY = window.scrollY;
      var headerHeight = window.matchMedia('(min-width: 1024px)').matches ? 75 : 70;
      var scrollY = currentY + targetY - headerHeight;

      window.scroll({
        top: scrollY,
        left: 0,
        behavior: 'smooth',
      });

      document.dispatchEvent(new CustomEvent('landing-header:close', { bubbles: true }));
    }
  }

  if (!customElements.get('image-text-blocks-section')) {
    customElements.define('image-text-blocks-section', ImageTextBlocksSection);
  }
})();
